import { render, staticRenderFns } from "./performance-description-table-read-header.component.vue?vue&type=template&id=e22b04ee&scoped=true&"
import script from "./performance-description-table-read-header.component.vue?vue&type=script&lang=ts&"
export * from "./performance-description-table-read-header.component.vue?vue&type=script&lang=ts&"
import style0 from "./performance-description-table-read-header.component.vue?vue&type=style&index=0&id=e22b04ee&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22b04ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
